<script>
import { mapActions } from "vuex";
import DetailButton from "@/components/_Shared/Orders/Show/DetailButton";
import orderMixin from "@/mixins/orderMixin";
import dateMixin from "@/mixins/dateMixin";
import accountMixin from "@/mixins/accountMixin";

export default {
  components: { DetailButton },
  mixins: [orderMixin, dateMixin, accountMixin],
  props: {
    order: { type: Object, required: true }
  },
  data() {
    return {
      preloader: false,
      dialog: false,
      confirmPaymentResult: false,
      confirmPaymentMessage: "",
      confirmPaymentImage: ""
    };
  },
  methods: {
    ...mapActions("orders", ["confirmPayment"]),
    showDialog() {
      this.dialog = true;
    },
    resetFlags() {
      this.preloader = false;
      this.dialog = false;
      this.confirmPaymentResult = false;
      this.confirmPaymentMessage = "";
    },
    showConfirmPaymentMessage(message, image) {
      this.confirmPaymentResult = true;
      this.confirmPaymentMessage = message;
      this.confirmPaymentImage = image;
    },
    async confirmOrderPayment() {
      this.preloader = true;
      try {
        await this.confirmPayment(this.order.id);
        this.showConfirmPaymentMessage(
          "Pagamento confirmado!!",
          "/static/icon_check_circle.svg"
        );
        setTimeout(() => {
          this.resetFlags();
          this.$emit("refresh");
        }, 2500);
      } catch (error) {
        this.showConfirmPaymentMessage(
          "Não foi possível confirmar o pagamento.",
          "/static/cancel.svg"
        );
        setTimeout(() => this.resetFlags(), 2500);
      }
    }
  }
};
</script>

<template>
  <div>
    <DetailButton
      @clicked="showDialog()"
      :disabled="false"
      imageSrc="/static/wallet-withdraw.svg"
      title="CONFIRMAR PAGAMENTO"
    />
    <v-dialog v-model="dialog" min-width="320" max-width="500">
      <v-card>
        <v-card-title class="title">
          <span>Deseja confirmar o pagamento?</span>
        </v-card-title>
        <v-divider light></v-divider>
        <v-card-text>
          <v-spacer></v-spacer>
          Limpeza da(o)
          <strong>{{ this.order.customer.account | fullName }}</strong> com o
          profissional
          <strong>{{ this.order.professional.account | fullName }}</strong> no
          dia
          <strong
            >{{
              this.order.schedule_event.starts_at | formatDate("DD/MM/Y HH:mm")
            }}h
          </strong>
          com
          <strong>{{
            this.order.schedule_event.duration | durationInHous
          }}</strong>
          de duração
        </v-card-text>
        <v-divider light></v-divider>
        <v-card-actions>
          <v-container grid-list-md>
            <v-layout v-if="confirmPaymentResult" row class="icon-wallet">
              <v-flex md3><img :src="confirmPaymentImage"/></v-flex>
              <v-flex md9 class="message-confirm-payment-result">
                <p>{{ confirmPaymentMessage }}</p>
              </v-flex>
            </v-layout>
            <v-layout v-else wrap>
              <v-flex xs-6>
                <v-btn
                  class="modal-button"
                  color="primary"
                  outlined
                  @click="dialog = false"
                  >Não</v-btn
                >
              </v-flex>
              <v-flex xs-6>
                <v-btn
                  :loading="preloader"
                  class="modal-button"
                  color="primary"
                  @click="confirmOrderPayment()"
                  >SIM, CONFIRMO O PAGAMENTO</v-btn
                >
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<style scoped>
.message-confirm-payment-result {
  color: var(--purple);
  font-size: 1px;
  align-self: center;
}

.message-confirm-payment-result p {
  margin-bottom: 0;
}

.modal-button {
  width: 100%;
}

.v-divider {
  margin: 0 5% 0 5%;
}

.icon-wallet {
  background-color: #fff;
  height: 50px;
}

.icon-wallet img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  object-position: center;
}
</style>



// WEBPACK FOOTER //
// src/components/Orders/ShowOrder/ConfirmPayment.vue